import { Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import { DateBox, TextArea, TextBox } from '../../../shared/controls/form';
import SelectBox from '../../../shared/controls/form/selectBox';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../../redux/selector';
import PaginatedDropdown from '../../../shared/component/PaginatedDropdown';
import apiServices from '../../../services/service';
import ChildProduct from '../../../components/sharedChild/childProduct';
import { validationSchemaQuote } from './validationSchema';

const RegularQuoteForm = ({
  formData,
  selectedOptions,
  handleSubmit,
  handleChangeForm,
  handleChange,
  errormsg,
  refs,
  handleAddRow,
  handleDeleteRow,
  handleAddProductToQuoteItems,
  productsByAccountId,
  priceSheetByProductId,
  handleSameAsBillingChange,
}) => {
  const owner = useSelector(getActiveOwners);
  const carrier = useSelector(getGenericMasterFilteredListByKey('Carrier'));
  const quoteStage = useSelector(getGenericMasterFilteredListByKey('QuoteStage'));
  const {
    options: accountOptions,
    isLoading: isAccountLoading,
    handleSearch: handleAccountSearch,
    handleScroll: handleAccountScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getAccountsDropdown,
    responseKey: 'accountList',
  });

  const {
    options: opportunityListDropdown,
    isLoading: isOpportunityLoading,
    handleSearch: handleOpportunitySearch,
    handleScroll: handleOpportunityScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getOpportunityDropdown,
    responseKey: 'opportunityList',
  });

  const {
    options: contactListDropdown,
    isLoading: isContactLoading,
    handleSearch: handleContactSearch,
    handleScroll: handleContactScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getContactsDropdown,
    responseKey: 'contactList', // expected response key
  });

  const leadSourceDropdown = useSelector(getGenericMasterFilteredListByKey('LeadSource'));
  const timeZone = useSelector(getGenericMasterFilteredListByKey('TimeZone'));
  const salutation = useSelector(getGenericMasterFilteredListByKey('Salutation'));

  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaQuote}
    >
      <Form>
        <div className="collapse_card mb-3">
          <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
            <div className="row gx-3">
              {/* Quote Information */}
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/quoteAi/images/quoteInfo.svg" alt="" />
                      Quote Information
                    </label>
                  </div>
                  <div className="quoteContent leadDetailInfo ">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label={'Quote Owner'}
                              name={'quoteOwnerId'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.quoteOwner || '--'
                                  : formData?.quoteOwner || 'Select Quote Owner'
                              }
                              // isRequired={true}
                              disabled={formData?.type === 'view'}
                              selectedOptions={selectedOptions?.quoteOwnerId}
                              handleSelect={handleChange}
                              options={owner}
                              optionKeys={['userId', 'display_name']}
                              errormsg={errormsg?.quoteOwnerId}
                              nameFormatter={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label={'Quote Stage'}
                              name={'quoteStageId'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.quoteStageName || '--'
                                  : formData?.quoteStageName || 'Select Quote Stage'
                              }
                              isRequired={false}
                              disabled={formData?.type === 'view'}
                              selectedOptions={selectedOptions?.quoteStageId}
                              handleSelect={handleChange}
                              options={quoteStage}
                              optionKeys={['id', 'displayName']}
                              errormsg={errormsg?.quoteStageId}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <TextBox
                              isRequired={true}
                              label={'Subject'}
                              name={'subject'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter Subject'}
                              value={formData?.subject}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.subject}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <TextBox
                              isRequired={false}
                              label={'Team'}
                              name={'team'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter Team'}
                              value={formData?.team}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.team}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container showarrow">
                            <SelectBox
                              label={'Carrier'}
                              name={'carrierId'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.carrierName || '--'
                                  : formData?.carrierName || 'Select Carrier'
                              }
                              isRequired={false}
                              disabled={formData?.type === 'view'}
                              selectedOptions={selectedOptions?.carrierId}
                              handleSelect={handleChange}
                              options={carrier}
                              optionKeys={['id', 'displayName']}
                              errormsg={errormsg?.carrierId}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <div className="dateBox">
                              <label>Valid Until</label>
                              {formData?.type === 'view' ? (
                                <>
                                  {formData?.validUntil
                                    ? new Date(formData.validUntil).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                      })
                                    : '--'}
                                </>
                              ) : (
                                <div className="dtBox custom-date-wrapper">
                                  <DateBox
                                    name="validUntil"
                                    className="custom-date-input"
                                    placeholder={
                                      formData?.type === 'view'
                                        ? '--'
                                        : 'Enter Valid Until (MM/DD/YYYY)'
                                    }
                                    value={
                                      formData?.validUntil
                                        ? formData?.validUntil.substring(0, 10)
                                        : ''
                                    }
                                    handleChange={handleChangeForm}
                                    errormsg={errormsg?.validUntil}
                                    disabled={formData?.type === 'view'}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/quoteAi/images/quoteInfo.svg" alt="" />
                      Association With
                    </label>
                  </div>
                  <div className="quoteContent leadDetailInfo ">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              isRequired={true}
                              label={'Account Name'}
                              name={'accountId'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.accountName || '--'
                                  : formData?.accountName || 'Select Account Name'
                              }
                              //   isRequired={true}
                              disabled={formData?.type === 'view'}
                              selectedOptions={selectedOptions?.accountId}
                              handleSelect={handleChange}
                              options={accountOptions}
                              optionKeys={['id', 'name']}
                              errormsg={errormsg?.accountId}
                              isLoading={isAccountLoading}
                              onSearch={handleAccountSearch}
                              onScrollToBottom={handleAccountScroll}
                              fieldType={'accountId'}
                              fieldId={formData?.accountId}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label={'Opportunity Name'}
                              name="opportunityId"
                              handleSelect={handleChange}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.opportunityName || '--'
                                  : formData?.opportunityName || 'Select Opportunity Name'
                              }
                              selectedOptions={selectedOptions?.opportunityId}
                              options={opportunityListDropdown}
                              isLoading={isOpportunityLoading}
                              onScrollToBottom={handleOpportunityScroll}
                              onSearch={handleOpportunitySearch}
                              optionKeys={['id', 'name']}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label="Contact Name"
                              name={'contactId'}
                              handleSelect={handleChange}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.contactName || '--'
                                  : formData?.contactName || 'Select Contact Name'
                              }
                              selectedOptions={selectedOptions?.contactName}
                              options={contactListDropdown}
                              isLoading={isContactLoading}
                              onScrollToBottom={handleContactScroll}
                              onSearch={handleContactSearch}
                              optionKeys={['id', 'name']}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              {/* Address Information */}
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/quoteAi/images/companyInfo.svg" alt="" />
                      Address Information
                    </label>
                  </div>
                  <div className="quoteContent leadDetailInfo">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-6 col-md-6">
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-1 mb-2">
                              <h3>Billing Address</h3>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Billing Street'}
                                  name={'billingStreet'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Street'}
                                  value={formData?.billingStreet}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.billingStreet}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Billing City'}
                                  name={'billingCity'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter City'}
                                  value={formData?.billingCity}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.billingCity}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Billing State'}
                                  name={'billingState'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter State'}
                                  value={formData?.billingState}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.billingState}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Billing Country'}
                                  name={'billingCountry'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Country'}
                                  value={formData?.billingCountry}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.billingCountry}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Billing Code'}
                                  name={'billingCode'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Code'}
                                  value={formData?.billingCode}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.billingCode}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6">
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-1 mb-1 d-flex align-items-center justify-content-between">
                              <h3>Shipping Address</h3>
                              {formData?.type !== 'view' && (
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="sameAsBilling"
                                    checked={formData?.sameAsBilling || false}
                                    onChange={handleSameAsBillingChange}
                                    disabled={
                                      !formData?.billingStreet &&
                                      !formData?.billingCity &&
                                      !formData?.billingState &&
                                      !formData?.billingCountry &&
                                      !formData?.billingCode
                                    }
                                  />
                                  <label className="form-check-label mt-1" htmlFor="sameAsBilling">
                                    Same as Billing Address
                                  </label>
                                </div>
                              )}
                            </div>

                            {/* Shipping Street */}
                            <div
                              className="col-12 col-sm-12 col-md-12 col-lg-12"
                              ref={refs?.companyName}
                            >
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping Street'}
                                  name={'shippingStreet'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Shipping Street'
                                  }
                                  value={formData?.shippingStreet}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingStreet}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            {/* City */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping City'}
                                  name={'shippingCity'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter City'}
                                  value={formData?.shippingCity}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingCity}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            {/* State */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping State'}
                                  name={'shippingState'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter State'}
                                  value={formData?.shippingState}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingState}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            {/* Country */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping Country'}
                                  name={'shippingCountry'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Country'}
                                  value={formData?.shippingCountry}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingCountry}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            {/* Code */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping Code'}
                                  name={'shippingCode'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Code'}
                                  value={formData?.shippingCode}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingCode}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              <ChildProduct
                rowData={formData}
                handleChangeForm={handleChangeForm}
                handleAddRow={handleAddRow}
                formData={formData}
                handleChange={handleChange}
                selectedOptions={selectedOptions}
                handleDeleteRow={handleDeleteRow}
                handleAddProductToQuoteItems={handleAddProductToQuoteItems}
                productsByAccountId={productsByAccountId}
                priceSheetByProductId={priceSheetByProductId}
                errormsg={errormsg}
              />
              {/* Quote Items Table */}
              {/* <QuoteItems /> */}
              {/* Additional Details */}
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img
                        className="me-2"
                        src="../assets/quoteAi/images/additionalInfo.svg"
                        alt=""
                      />
                      Additional Details
                    </label>
                  </div>
                  <div className="quoteContent leadDetailInfo notesLabel">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Terms and Conditions'}
                              name={'termsAndConditions'}
                              placeholder={
                                formData?.type === 'view' ? '--' : 'Enter Terms and Conditions'
                              }
                              value={formData?.termsAndConditions}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.termsAndConditions}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Description'}
                              name={'descriptionInformation'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                              value={formData?.descriptionInformation}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.descriptionInformation}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default RegularQuoteForm;
